import { create } from 'zustand';

type Role = 'investor' | 'owner' | 'developer' | 'admin' | null;

interface SessionState {
  token: string | null;
  role: Role;
  setSession: (token: string | null, role: Role) => void;
  clearSession: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  token: null,
  role: null,
  setSession: (token, role) => set({ token, role }),
  clearSession: () => set({ token: null, role: null }),
}));
